import { generatedApi } from './api.generated';
import {
  createEndpointExports,
  createHookExports,
  provideListTags,
  LIST_TAG_ID,
} from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { DEX_TOKEN_MAP_API_ENDPOINTS as cfg } from './config';

/**
 * Cache tags follow the recommended `id: 'LIST'` recipe:
 * https://redux-toolkit.js.org/rtk-query/usage/automated-refetching#recipes
 *
 * The token map is a single global collection. `getTokenMap` provides a
 * per-item tag for every binding plus a dedicated `{ type: 'TokenMap', id: 'LIST' }`
 * tag, and the `bind` / `unbind` mutations invalidate `{ id: 'LIST' }` so the
 * collection refetches without touching unrelated caches. The list response is
 * wrapped (`result.data` is the bindings array), so per-item tags are derived
 * from `result.data`.
 */
const enhancedDexTokenMapApi = generatedApi.enhanceEndpoints({
  addTagTypes: ['TokenMap'],
  endpoints: {
    [cfg.getTokenMap.generated]: {
      providesTags: (result) => provideListTags(result?.data, 'TokenMap'),
    },
    [cfg.bindTokenMap.generated]: {
      invalidatesTags: [{ type: 'TokenMap', id: LIST_TAG_ID }],
    },
    [cfg.unbindTokenMap.generated]: {
      invalidatesTags: [{ type: 'TokenMap', id: LIST_TAG_ID }],
    },
  },
});

export const dexTokenMapApi: typeof enhancedDexTokenMapApi = enhancedDexTokenMapApi;

export const hookExports: HookExports<typeof cfg, typeof dexTokenMapApi> = createHookExports(
  cfg,
  dexTokenMapApi,
);

const endpointExports = createEndpointExports(cfg, dexTokenMapApi);

export const dexTokenMapApiEndpoints: typeof endpointExports = endpointExports;
